import { Component, OnInit, Renderer2 } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { StorageService } from "../../services/storage.service";
import { UpdateRoleModalComponent } from "../update-role-modal/update-role-modal.component";

function noSpaceValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && /\s/.test(control.value)) {
    return { noSpaces: true };
  }
  return null;
}
@Component({
  selector: "app-user-management",
  styleUrls: ["./user-management.component.css"],
  templateUrl: "./user-management.component.html",
})
export class UserManagementComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  userID = parseInt(this.ls.get("createdBy"));
  AdminForm: FormGroup;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  swal: any;
  total_count = 0;
  admcreate: any;
  adminList: any[];
  getadmin: any;
  editadmin: any;
  is_active = false;
  deleteadmin: any;
  editstatus = false;
  admupdate: any;
  admstatusupdate: any;
  editid: any;
  isactiveswitch: any;
  editbut = false;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  first_name: any;
  last_name: any;
  email_address: any;
  mobile_number: any;
  username: any;
  total: number;
  p: number;
  pagedItems: any[];
  readwrite: any;
  writeaccess = this.ls.get("write_access");
  write: any;
  searchForm: FormGroup;
  chiparray: any = [];
  filtervalues: boolean;
  entryFields: boolean = false;
  createNew: boolean = true;
  addingRoleData: any;
  manualUpdate: boolean;
  backendValidationErrors: null;
  activeRowAdminData: any;
  getroles: Object;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      fname: [""],
      lname: [""],
      uname: [""],
      email: [""],
      mobile: [""],
    });

    this.AdminForm = this.fb.group({
      id: [""],
      first_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      last_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      username: ["", [Validators.required, noSpaceValidator]],
      email_address: ["", [Validators.required]],
      mobile_number: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],

      write: [""],
      is_active: [""],
      role_id: [""],
    });
    this.page = 1;
    this.AdminForm.valueChanges.subscribe((data) => {
      this.backendValidationErrors = null;
    });
    await this.getAdmin();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.AdminForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.AdminForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.AdminForm.reset();
    this.createNew = true;
  }
  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall){
      await this.getAdmin();
    }
    const res = await this.serverCall(this.adminList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  get forms() {
    return this.AdminForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }

  switch(e) {
    this.isactiveswitch = e;
  }
  readWrite(e) {
    this.readwrite = e;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  async createAdmin(form: FormGroup) {
    this.submitted = true;
    this.spinner.show();

    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      username: form.value.username,
      email_address: form.value.email_address,
      mobile_number: form.value.mobile_number,

      write_access: this.readwrite == true ? "1" : "0",
      is_active: this.isactiveswitch
        ? this.isactiveswitch == true
          ? "1"
          : "0"
        : "0",

      role_id: 3,
    };

    this.admcreate = await this.globalService.create(
      "commonUser/create",
      inputData
    );

    if (this.admcreate["status"] === 200) {
      Swal.fire("Success!", this.admcreate["message"], "success");
      this.spinner.show();
      this.pageshow = true;
      this.getAdmin();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, "modal-open");
    } else if (this.admcreate["status"] === 422) {
      this.backendValidationErrors = this.admcreate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  async getAdmin() {
    this.spinner.show();
    if (this.page === 1) {
      this.adminList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size: this.page_size,
      first_name: this.first_name,
      last_name: this.last_name,
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      username: this.username,
    };

    this.getadmin = await this.globalService.get("commonUser/list", filter);
  

    if (this.getadmin["status"] === 200) {
      this.adminList = this.getadmin["content"]["rows"];
      this.total_count = this.getadmin["content"].count;
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.htmlpageshow = false;
      this.spinner.hide();
    }

    (error) => {
      this.adminList = [];
      this.spinner.hide();
    };

    this.spinner.hide();
  }

  editAdmin(id) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.editadmin = await this.globalService.get("commonUser/get", filter);
        let comp_details = this.editadmin["content"];

        if (this.editadmin["status"] === 200) {
          if (comp_details.id == this.userID) {
            this.AdminForm.controls["is_active"].disable();
            this.AdminForm.controls["write"].disable();
          } else {
            this.AdminForm.controls["is_active"].enable();
            this.AdminForm.controls["write"].enable();
          }
          this.AdminForm.controls["id"].setValue(comp_details.id);
          this.AdminForm.controls["first_name"].setValue(
            comp_details.first_name
          );
          this.AdminForm.controls["write"].setValue(comp_details.write_access);
          this.AdminForm.controls["last_name"].setValue(comp_details.last_name);
          this.AdminForm.controls["username"].setValue(comp_details.username);
          this.AdminForm.controls["email_address"].setValue(
            comp_details.email_address
          );
          this.AdminForm.controls["mobile_number"].setValue(
            comp_details.mobile_number
          );

          this.AdminForm.controls["is_active"].setValue(comp_details.is_active);
          this.AdminForm.controls["role_id"].setValue(comp_details.role_id);

          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;

          this.write = comp_details.write_access;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }

  reset() {
    this.submitted = false;
    this.AdminForm.reset();
    this.editstatus = false;
    this.readwrite = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getAdmin();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getAdmin();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getAdmin();
  }
  AdminStatus(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };

        this.admstatusupdate = await this.globalService.update(
          "commonUser/update/status",
          inputData
        );
        if (this.admstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.admstatusupdate["message"], "success");
          this.pageshow = true;
          this.getAdmin();
        }
        if (this.admstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getAdmin();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getAdmin();
      }
    });
    this.spinner.hide();
  }

  async updateAdmin(form: FormGroup) {
    this.submitted = true;
    this.spinner.show();
    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      is_active: form.controls["is_active"].value ? "1" : "0",
      user_id: this.ls.get("createdBy"),
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      username: form.controls["username"].value,
      email_address: form.value.email_address,
      mobile_number: form.value.mobile_number,
      role_id: form.value.role_id,
      write_access: form.controls["write"].value ? 1 : 0,
    };

    this.admupdate = await this.globalService.update(
      "commonUser/update",
      inputData
    );

    if (this.admupdate["status"] === 200) {
      Swal.fire("Success!", this.admupdate["message"], "success");
      this.spinner.show();
      this.pageshow = true;
      this.getAdmin();
      this.editbut = false;
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, "modal-open");
    } else if (this.admupdate["status"] === 422) {
      this.backendValidationErrors = this.admupdate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  async deleteAdmin(id, role) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: this.ls.get("role"),

          id: id,
        };
        this.deleteadmin = await this.globalService.delete(
          "commonUser/delete",
          filter
        );
        if (this.deleteadmin["status"] === 200) {
          this.adminList = [];
          Swal.fire("Success!", this.deleteadmin["message"], "success");
          this.pageshow = true;
          this.getAdmin();
          this.spinner.hide();
        }
        this.spinner.hide();
      }
    });
    this.spinner.hide();
  }

  AdminStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };

        this.admstatusupdate = await this.globalService.update(
          "commonUser/update/status",
          inputData
        );
        if (this.admstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.admstatusupdate["message"], "success");
          this.pageshow = true;
          this.getAdmin();
        }
        if (this.admstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getAdmin();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getAdmin();
      }
    });
    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  openAddRole(admin) {
    if (this.ls.get("token")) {
      const modalRef = this.modalService.open(UpdateRoleModalComponent, {
        scrollable: true,
      });
      modalRef.componentInstance.userDetails = admin;
      modalRef.componentInstance.roleList = [
        { id: 4, name: "Professor" },
        { id: 5, name: "Learner" },
      ];
      modalRef.componentInstance.notifyParent.subscribe((e) => {
        if (e == "success") {
          this.getAdmin();
        }
      });
    }
  }

  getUserRoleDetails(user) {
    return user?.userByRole.map((e) => e.role).join(", ");
  }

  Filter(first_name, last_name, email_address, mobile_number, username) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.first_name != undefined && this.first_name != "") {
      this.chiparray.push("Fname :" + " " + this.first_name);
    }

    if (this.last_name != undefined && this.last_name != "") {
      this.chiparray.push("Lname :" + " " + this.last_name);
    }
    if (this.username != undefined && this.username != "") {
      this.chiparray.push("Uname :" + " " + this.username);
    }
    if (this.email_address != undefined && this.email_address != "") {
      this.chiparray.push("Email :" + " " + this.email_address);
    }
    if (this.mobile_number != undefined && this.mobile_number != "") {
      this.chiparray.push("Mobile :" + " " + this.mobile_number);
    }

    this.first_name = first_name;
    this.last_name = last_name;
    this.email_address = email_address;
    this.mobile_number = mobile_number;
    this.username = username;
    this.pageshow = true;
    this.page = 1;
    this.getAdmin();
  }
  res() {
    this.filtervalues = false;
    this.chiparray = [];
    this.first_name = null;
    this.last_name = null;
    this.email_address = null;
    this.mobile_number = null;
    this.username = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getAdmin();
  }
  formAddReset() {
    this.AdminForm.reset();
    this.editbut = false;
  }
  formupdateReset() {
    this.AdminForm.controls["id"].setValue(this.editadmin["content"].id);
    this.AdminForm.controls["first_name"].setValue(
      this.editadmin["content"].first_name
    );
    this.AdminForm.controls["write"].setValue(
      this.editadmin["content"].write_access
    );
    this.AdminForm.controls["last_name"].setValue(
      this.editadmin["content"].last_name
    );
    this.AdminForm.controls["email_address"].setValue(
      this.editadmin["content"].email_address
    );
    this.AdminForm.controls["mobile_number"].setValue(
      this.editadmin["content"].mobile_number
    );
    this.AdminForm.controls["is_active"].setValue(
      this.editadmin["content"].is_active
    );
    this.AdminForm.controls["role_id"].setValue(
      this.editadmin["content"].role_id
    );
    this.AdminForm.reset();

    this.AdminForm.controls["username"].setValue(
      this.editadmin["content"].username
    );
    this.AdminForm.get("id").setValue(this.editadmin["content"].id);
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getAdmin();
  }
}
